/**
 * Represents the type of a data owner
 */
export enum DataOwnerTypeEnum {
  Patient = 'patient',
  Hcp = 'hcp',
  Device = 'device',
}
